import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SocialLogin } from "app/account/social-login";

/**
 * Handle Dropbox login before loading a component
 */
@Injectable({
   providedIn: "root",
})
export class DropboxAuthGuardService  {
   constructor(private socialLogin: SocialLogin) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
      let accessToken = localStorage.getItem('access_token_dropbox');
      if (accessToken && (accessToken != null)) {
         return true;
      }
      return this.socialLogin.withDropBox().pipe(
         map( (userDropboxProfile) => {
            if (userDropboxProfile?.accessToken === localStorage.getItem('access_token_dropbox')) {
               // Success login Dropbox
               return true;
            }
            return false;
         })
      );
   }
}
